module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/my251Y/images/cover.jpg?1696786155887",
      "alt": "This image is the cover for the book Wicked Adirondacks, Wicked"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wicked Adirondacks, Wicked\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("While the Adirondack Mountains are New York's most beautiful region, they have also been plagued by insidious crimes and the nasty escapades of notorious lawbreakers. In 1935, public enemy number one, Dutch Schultz, went on trial and was acquitted in an Adirondack courtroom. Crooks have tried creative methods to sidestep forestry laws that protect the flora of the state park. Members of the infamous Windfall Gang, led by Charles Wadsworth, terrorized towns and hid out in the high mountains until their dramatic 1899 capture. In the 1970s, the Adirondack Serial Killer, Robert Francis Garrow, petrified campers in the hills. Join local author Dennis Webster as he explores the wicked deeds and sinister characters hidden among the Adirondacks' peaks.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dennis Webster\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dennis Webster is the author of Wicked Mohawk Valley and Haunted Mohawk Valley and editor, compiler and story contributor to Adirondack Mysteries, volumes 1 and 2, as well as the fiction novel Daisy Daring & the Quest for the Loomis Gang Gold. He's a paranormal investigator with the Ghost Seekers of Central New York. He lives in the foothills of the Adirondack Mountains with his family and his howling beagle. He can be reached at denniswbstr@gmail.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0